// src/components/ContactForm.js

import React, { useState } from 'react';
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  useTheme
} from '@mui/material';

export default function ContactForm() {
  const theme = useTheme();
  const accentColor = theme.palette.secondary.main; // should match your Accent bar color

  const [values, setValues] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (field) => (e) => {
    setValues({ ...values, [field]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg('');
    setSuccessMsg('');

    try {
      const res = await fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });
      if (!res.ok) throw new Error(`Server responded ${res.status}`);
      setSuccessMsg('Thanks! We’ve received your request and will be in touch soon.');
      setValues({ name: '', email: '', subject: '', message: '' });
    } catch {
      setErrorMsg('Oops! Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ bgcolor: 'common.white', py: { xs: 6, md: 8 } }}>
      <Container maxWidth="sm">
        {/* Heading */}
        <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 700 }}>
          Get in Touch
        </Typography>
        {/* Accent bar */}
        <Box
          sx={{
            width: 80,
            height: 4,
            bgcolor: accentColor,
            borderRadius: 2,
            mx: 'auto',
            mb: 4,
          }}
        />

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            p: { xs: 3, md: 4 },
            borderRadius: 2,
            boxShadow: 3,
            bgcolor: 'background.paper',
          }}
        >
          {errorMsg && <Alert severity="error">{errorMsg}</Alert>}
          {successMsg && <Alert severity="success">{successMsg}</Alert>}

          <TextField
            label="Your Name"
            placeholder="Jane Doe"
            value={values.name}
            onChange={handleChange('name')}
            required
            fullWidth
          />

          <TextField
            label="Your Email"
            type="email"
            placeholder="you@example.com"
            value={values.email}
            onChange={handleChange('email')}
            required
            fullWidth
          />

          <TextField
            label="Subject"
            placeholder="How can we help?"
            value={values.subject}
            onChange={handleChange('subject')}
            required
            fullWidth
          />

          <TextField
            label="Message"
            placeholder="Tell us more..."
            value={values.message}
            onChange={handleChange('message')}
            required
            multiline
            rows={5}
            fullWidth
          />

          <Box sx={{ position: 'relative', textAlign: 'center', mt: 2 }}>
             <Button
                    type='submit'
                    variant="contained"
                    size="large"
                    fullWidth
                      sx={{
                      backgroundColor: theme.palette.grey[900],
                      color: theme.palette.common.white,
                      fontFamily: '"Playfair Display", serif',
                              '&:hover': { backgroundColor: theme.palette.grey[800] },
                            }}
                          >
                            Submit Request
                          </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: accentColor,
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  mt: '-12px',
                  ml: '-12px',
                }}
              />
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
